export const pathoIndex = {
  pathogenic: 0,
  benign: 1,
  "likely benign": 2,
  "uncertain significance": 3,
  "likely pathogenic": 4,
  unknown: 5,
};

export const cnvTypeIndex = {
  DUP: 0,
  DEL: 1,
  other: 2,
  "": 2,
};

export const cnvTypeLabel = {
  0: "Duplication",
  1: "Deletion",
  2: "Other",
};

export const types = {
  // dups
  DUP: 1,
  Duplication: 22,
  duplication: 8,
  "tandem duplication": 18,
  "Tandem duplication": 37,
  "Duplication/Triplication": 32,
  // dels
  DEL: 0,
  deletion: 7,
  Deletion: 23,
  "sva deletion": 27,
  "alu deletion": 25,
  "mobile element deletion": 21,
  "line1 deletion": 10,
  "herv deletion": 29,

  // ins
  insertion: 9,
  INS: 4,
  "alu insertion": 17,
  "mobile element insertion": 24,
  "novel sequence insertion": 19,
  "sva insertion": 20,
  "line1 insertion": 26,
  "herv insertion": 28,

  // gain
  "copy number gain": 2,
  gain: 6,
  "Copy-Number Gain": 34,

  // loss
  "copy number loss": 12,
  loss: 16,

  //
  MCNV: 3,

  CNV: 5,

  undefined: 11,
  CPX: 13,
  INV: 14,
  "gain+loss": 15,
  Triplication: 30,
  Amplification: 31,
  Complex: 33,
  Inversion: 35,
  CTX: 36,
};
